import { render, staticRenderFns } from "./FbRequests.vue?vue&type=template&id=60cdf373&scoped=true&"
import script from "./FbRequests.vue?vue&type=script&lang=js&"
export * from "./FbRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60cdf373",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('60cdf373', component.options)
    } else {
      api.reload('60cdf373', component.options)
    }
    module.hot.accept("./FbRequests.vue?vue&type=template&id=60cdf373&scoped=true&", function () {
      api.rerender('60cdf373', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/systemAnalytics/FbRequests.vue"
export default component.exports